export const calculateAdditionalCoveragesQuery = `mutation CalculateAdditionalCoverages($input: CalculateAdditionalCoveragesInput!) { 
  calculateAdditionalCoverages(input: $input) { 
    calculateAdditionalCoveragesResult { 
      policyDetails { 
        totalInstallmentAmount 
        effectiveDate 
        grossPremiumInstallment 
        surchargesInstallmentAmount 
        discountsInstallmentAmount 
        netPremiumInstallment 
        costsInstallmentAmount 
        insuranceTaxInstallmentAmount 
        paymentTermInMonths 
        renewalCommissionInstallmentAmount 
        productDescription 
        porCompany
        companyNameDescription
        refKey
        orderFormId
        productCode
        conditionConditionDetails { 
          conditionNumber
          conditionText
          url
        } 
        masterAgreementPackages { 
          productDescription 
        } 
        objectMotorVehicles { 
          licensePlate 
          reportCode 
          text
          annualMileage
          rdwVehicleCategory
          coverageThirdPartyLiabilities {
            productDescription
          }
          partyRegularDrivers {
            numberOfClaimFreeYears
          }
          coverageHullVehicles {
            deductibleAmount
            productDescription
            sumInsured
          }
          coverageAny { 
            commercialName
            totalInstallmentAmount
            netPremiumInstallment
            insuranceTaxInstallmentAmount
            refKey
            productDescription
            description
          }
          documents {
            urlAttachment
            attachmentDescription
          }
        }
        customProperties {
          supplierKrn
        }
      }
      commonTechnical {
        accessCode
        transactionReference
        senderId
        sessionId
      }
    } 
  } 
}`;
